<template>
  <div  v-if="isLargeScreen">

    <div>
      <Breadcrumbs main="Reports" title="Reports" />

      <div class="container-fluid">
          <div class="row widget-grid m-lg-5 d-flex align-items-stretch">
              <Datepicker />
              <TotalCard />
              <TransactionsChart />
              <BarChart />
              <DonutChart />
              <Summary />
          </div>
      </div>
      </div>
  </div>
  <div v-else>
    <MobileReport />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import DonutChart from './donutChart.vue';
import TransactionsChart from './transactionsChart.vue';
import TotalCard from './totalCard.vue';
import BarChart from './barChart.vue';
import Summary from './summary.vue';
import Datepicker from './datepicker.vue';
import MobileReport from './mobile/index.vue'

const isLargeScreen = ref(true);
  
  // 檢查螢幕大小
  function checkScreenSize() {
    isLargeScreen.value = window.innerWidth >= 992;
  }
  
  onMounted(() => {
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
  });
  
  onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize);
  });

</script>